import { derived } from 'svelte/store';
import type { TranslationKey } from './types';
import { getMessage, interpolate } from './utils';
import { messages } from './messages';

export const t = derived(messages, ($messages) => {
  return function translate(key: TranslationKey, values: Record<string, string> = {}) {
    return interpolate(getMessage($messages, key), values);
  };
});
